module.exports = __webpack_public_path__ + "img/lite-badge.73b83a36.svg";